export default __webpack_public_path__ + "static/media/1.1c10e9b0.jpg";